module.exports = __webpack_public_path__ + "media/images/howtoplay2-e0a5c47a556a88442081ef679f2cec04.png";